import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { messageActions } from '../../../application/actions/message';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETALL
export function* getAllFetch() {
    yield put(messageActions.conexionGetAll({connection:true}));
    try {
        const url = `message/user`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(messageActions.getAll({data}));
    } catch (err) {
        yield put(messageActions.errorGetAll({error:true, message:err.message}));
    } finally {
        yield put(messageActions.conexionGetAll({connection:false}));
    }
}

// GETBYID
export function* getByIdFetch(e) {
    yield put(messageActions.conexionGetById({connection:true}));
    try {
        const  params  = e.payload;
        console.log(params)
        const url = `message/case/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(messageActions.getById({data}));
    } catch (err) {
        yield put(messageActions.errorGetById({error:true, message:err.message}));
    } finally {
        yield put(messageActions.conexionGetById({connection:false}));
    }
}

// CREATE
export function* createFetch(e) {
    yield put(messageActions.conexionCreate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `message`
        const response = yield call(
            apiRequest.post,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(messageActions.create({result}));
    } catch (err) {
        yield put(messageActions.errorCreate({error:true, message:err.message}));
    } finally {
        yield put(messageActions.conexionCreate({connection:false}));
    }
}
// UPDATE
export function* updateFetch(e) {
    yield put(messageActions.conexionUpdate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `message/${params.id}`
        const response = yield call(
            apiRequest.put,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(messageActions.update({result}));
    } catch (err) {
        yield put(messageActions.errorUpdate({error:true, message:err.message}));
    } finally {
        yield put(messageActions.conexionUpdate({connection:false}));
    }
}

export function* watchFetchMessage() {
    yield takeLatest(messageActionsSaga.getAll.type,  getAllFetch);
    yield takeLatest(messageActionsSaga.getById.type,  getByIdFetch);
    yield takeLatest(messageActionsSaga.create.type,  createFetch);
    yield takeLatest(messageActionsSaga.update.type,  updateFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchMessage);
}


const getAll = createAction('messageSaga/getAll');
const getById = createAction('messageSaga/getById');
const create = createAction('messageSaga/create');
const update = createAction('messageSaga/update');

export const messageActionsSaga = {
    getAll,
    getById,
    create,
    update
};
